// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emp-query-container {
  display: flex;
  flex-direction: column;
  height: 100vh; /* Adjust as needed */
  width: 100%;
}

.emp-query-header {
  width: 96%;
  padding: 2%;
  text-align: left;
  font-weight: bold;
}

.emp-query-content {
  display: flex;
  flex: 1 1; /* Takes up full height */
  padding: 0 2%;
  gap: 2%;
}

.emp-sidebar {
  width: 30%;
  padding: 10px;
  background-color: #f8fafb;
  overflow-y: auto;
  border-radius: 10px;
  margin-bottom: 5%;
}

.emp-chat-container {
  width: 70%;
  padding: 10px;
  background-color: #ffffff;
  overflow-y: auto;
  border-radius: 10px;
  margin-bottom: 5%;
}

.emp-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.emp-resolved-btn {
  background: transparent;
  border: 2px solid #007bff;
  color: #007bff;
  padding: 8px 16px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 14px;
  transition: background 0.3s, color 0.3s;
}

.emp-resolved-btn.active {
  background: #007bff;
  color: white;
}

.emp-query-list {
  height: calc(100vh - 80px);
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 10px;
  }
}

.emp-query-list::-webkit-scrollbar {
  display: none;
}

.emp-query-list:hover::-webkit-scrollbar {
  display: block;
}

.emp-query-item {
  display: flex;
  align-items: center;
  padding: 10px;
  margin: 2%;
  cursor: pointer;
  transition: 0.2s;
  position: relative;
  border-bottom: 2px solid #ccc;
}

.emp-query-item:hover,
.emp-query-item.active {
  background: #ffffff;
  border-radius: 0;
  margin: 2%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
}

.emp-profile-pic {
  width: 40px;
  height: 40px;
  background: #ccc;
  border-radius: 50%;
  margin-right: 10px;
}

.emp-query-info {
  flex-grow: 1;
}

.emp-query-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.emp-name {
  font-weight: bold;
  margin: 0;
}

.emp-time {
  font-size: 12px;
  color: gray;
  margin: 10px;
}

.emp-message-preview {
  color: gray;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  display: inline-block;
  margin: 0;
}

.emp-unread-dot {
  top: 5px;
  right: 10px;
  width: 15px;
  height: 15px;
  margin: 0%;
  padding: 0;
  font-size: small;
  color: #fff;
  text-align: center;
  background-color: #0078ce;
  border-radius: 50%;
}

.emp-message-preview.unread-message {
  color: #0078ce;
}

.emp-time,
.emp-message-preview {
  margin: 0 0 0 10px;
}

.emp-query-header .name {
  flex-grow: 1;
}

/* Hide scrollbar */
.emp-chat-messages {
  display: flex;
  flex-direction: column-reverse;
  overflow-y: auto;
  height: 470px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

/* Hide scrollbar for WebKit (Chrome, Safari) */
.emp-chat-messages::-webkit-scrollbar {
  display: none;
}

/* Disabled input and button styles */
.emp-chat-input input:disabled,
.emp-chat-input button:disabled {
  background: #e0e0e0;
  cursor: not-allowed;
  opacity: 0.6;
}

.emp-message-container {
  display: flex;
  flex-direction: column;
}

.emp-message-header {
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 14px;
  color: #555;
  text-align: left; /* Default alignment for left */
}

.emp-message-container.right .emp-message-header {
  text-align: right; /* Align to the right for 'You' */
}

.emp-message-container.left .emp-message-header {
  text-align: left; /* Align to the left for others' names */
}

.emp-message {
  max-width: 60%;
  padding: 0.5%;
  border-radius: 10px 10px 10px 0;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.left .emp-message {
  background: #dbeafe;
  align-self: flex-start;
}

.right .emp-message {
  background: #001f3f;
  color: white;
  align-self: flex-end;
}

.emp-message-time {
  font-size: 12px;
  color: gray;
  display: block;
  margin-top: 5px;
}

.emp-chat-input {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin-top: 2%;
}

.input-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-wrapper {
  position: relative;
  width: 100%;
}

.message-input {
  width: 90%;
  padding: 1.5% 50px 1.5% 10px; /* Reduced right padding to make room for icon and suffix */
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.attachment-suffix {
  position: absolute;
  right: 80px;
  top: 50%;
  transform: translateY(-50%);
  color: #333;
  font-size: 14px;
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.attachment-icon {
  position: absolute;
  right: 4%;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #666;
  font-size: 20px;
  z-index: 2;
}

.attachment-icon:hover {
  color: #333;
}

/* For employee submit button, same interactive styles */
.emp-submit-btn {
  background-color: #7fbd2c;
  width: 10%;
  color: white;
  border: none;
  padding: 1.5% 2%;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

.emp-submit-btn:hover {
  background-color: #68a822; /* Slightly darker */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.emp-submit-btn:active {
  transform: scale(0.98);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.emp-submit-btn:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.emp-chat-input .submit-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.emp-select-query {
  text-align: center;
  margin-top: 50px;
  font-size: 18px;
  color: gray;
}

.employee-query-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.employee-query-modal {
  background-color: #e8e9ea;
  padding: 0;
  width: 600px;
  top: 8%;
  position: relative;
  font-family: "Arial", sans-serif;
}

.employee-query-textarea::placeholder {
  font-family: inherit;
  font-size: 1rem;
  color: #999;
}

.employee-query-input::placeholder {
  font-family: inherit;
  font-size: 1rem;
  color: #999;
}

.emp-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0% 5%;
  margin: 0;
  background-color: #00468c;
  color: #fff;
}

.emp-close-button {
  font-size: 1.5vw;
  cursor: pointer;
}

.compose-icon {
  padding: 0;
  font-size: large;
}

/* Form Fields */
.employee-query-form {
  margin: 0;
  padding: 5%;
  width: 90%;
}

.employee-query-field {
  margin-bottom: 15px;
}

.employee-query-label {
  display: block;
  font-weight: bold;
  color: #555;
  margin-bottom: 5px;
}

.employee-query-input,
.employee-query-textarea,
.employee-query-select {
  width: 100%;
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  margin-bottom: 10px;
  font-family: inherit;
}

.employee-query-textarea {
  resize: none;
  height: 100px;
}

.empform-cancel-button {
  width: 15%;
  padding: 1%;
  font-size: 1rem;
  color: #000;
  background-color: transparent;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  border: 0.2vw solid #79c42b;
  margin: 0 0 2% 60%;
}

/* Buttons */
.employee-query-button {
  padding: 1%;
  font-size: 1rem;
  color: #fff;
  background-color: #79c42b;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  border: 0.2vw solid #79c42b;
  margin-left: 2%;
}

.employee-query-button:hover {
  background-color: #218838;
}

.feedback-para {
  font-size: small;
  font-weight: bold;
}

.feedback-options {
  padding: 1% 5%;
}

.stars-container {
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  font-size: 24px;
  cursor: pointer;
  margin: 2% 0 5% 0;
}

.star {
  color: gray;
  transition: color 0.3s ease-in-out;
}

.star:hover,
.star.selected {
  color: gold;
}

.stars-info {
  color: blue;
  font-style: italic;
}

.thank-you {
  text-align: center;
  font-size: medium;
  font-weight: bold;
}

.thank-button {
  display: flex;
  justify-content: center;
  align-items: center;
}

.thank-close {
  background-color: #7fbd2c;
  color: #fff;
  padding: 1% 2%;
  margin: 2%;
  border-radius: 5px;
  border: none;
}

.compose {
  display: flex;
  justify-content: flex-end;
}

.end {
  display: flex;
  justify-content: flex-end;
  gap: 2%;
}

.compose-button {
  background-color: #0078ce;
  padding: 1% 2%;
  color: #fff;
  align-items: center;
  border-radius: 5px;
  font-size: 20px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

.compose-button:hover {
  background-color: #006bb3; /* Slightly darker blue */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.compose-button:active {
  transform: scale(0.98);
}

.compose-button:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.close-thread-button {
  background-color: #ffffff;
  border: 2px solid #0078ce;
  color: #0078ce;
  text-align: center;
  border-radius: 5px;
  padding: 0.5%;
  font-size: medium;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

.close-thread-button:hover {
  background-color: #f2f2f2;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.close-thread-button:active {
  transform: scale(0.98);
}

.close-thread-button:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.close-thread-icon {
  font-size: medium;
}

.message-text {
  padding: 0 1%;
}




@media (max-width: 768px) {
  /* Container Adjustments */
  .emp-query-container {
    height: 100%; /* Full height to fit screen */
    display: flex;
    height: 125vh;
    width: 98%;
    
    border-radius: 10px 30px 30px 10px;
    
    flex-direction: column;
    overflow: hidden; /* Prevent unnecessary scroll */
  }

  .emp-query-content {
    flex-direction: column; /* Stack sidebar & chat */
    gap: 10px;
    display: flex;
    flex-wrap: wrap;
    flex-grow: 0; /* Allow it to take full space */
    
  }

  /* Sidebar Adjustments */
  .emp-sidebar {
    width: 96%; /* Full width */

    /* overflow-x: auto; */
    /* padding: 10px 0; */
    /* white-space: nowrap;
    background: #f8f9fa; /* Light background */
 
    border-bottom: 1px solid #ddd;
  }

  /* Query List Adjustments */
  .emp-query-list {
    height: auto; /* Dynamic height */
    overflow-x: auto; /* Enable horizontal scrolling */
    overflow-y: hidden; /* Remove vertical scroll */
    display: flex;
    flex-wrap: nowrap; /* Keep items in one row */
    gap: 10px;
    padding: 5px;
    margin-top: -5%;
    align-items: center;
  }

  .emp-query-list::-webkit-scrollbar {
    height: 5px; /* Slightly larger for usability */
  }

  .emp-query-list::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.3); /* More visible scrollbar */
    border-radius: 10px;
  }

  /* Chat Section */
  .emp-chat-container {
    width: 100%;
    /* flex-grow: 1; /* Expand to fill space */
    display: flex;
    /* height: 50%; */
    height: 84vh;
    flex-direction: column;
    border-radius: 10px 30px 30px 10px;
 
    justify-content: space-between; 
  }

  .emp-chat-messages {
    max-height: calc(100vh - 300px); /* Adjust for screen space */
    overflow-y: auto;
    padding: 10px;
  }

  /* Input Field */
  .input-container {
    display: flex;
    gap: 5px;
    margin-top: 0%;
    margin-right: -2%;
    padding: 10px;
    align-items: center;
    background: white;
   
  }

  .input-container input {
    flex-grow: 1; /* Fill available space */
    font-size: 14px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  /* Submit Button */
  .emp-submit-btn {
    width: auto;
    padding: 10px 15px;
    font-size: 14px;
    background: #7fbd2c;
    color: white;
    margin-right: 9%;
    border-radius: 5px;
    border: none;
  }

  /* Modal */
  @media (max-width: 768px) {
    .employee-query-modal {
      width: 80%; /* Adjust modal width */
      top: 5%;
      padding: 3%;
    }
  
    .employee-query-textarea,
    .employee-query-input,
    .employee-query-select {
      font-size: 0.9rem;
      padding: 8px;
    }
  
    .emp-form-header {
      padding: 5%;
      font-size: 1rem;
    }
  
    .emp-close-button {
      font-size: 6vw!important; /* Increase close button size */
    }
  
    .employee-query-form {
      width: 100%;
      padding: 5%;
      margin-left: -4%;
    }
  
    .employee-query-button {
      width: 100%; /* Full width for better tapability */
      font-size: 1rem;
      padding: 10px;
      margin: 10px 0px 10px 0px;
    }
  
    .empform-cancel-button {
      width: 100%;
      margin: 10px 0;
      font-size: 1rem;
      padding: 10px;
    }
  
    .stars-container {
      font-size: 20px;
      justify-content: center;
      gap: 5px;
    }
  
    .feedback-options {
      padding: 3%;
    }
  
    .thank-you {
      font-size: 1rem;
    }
  
    .thank-button {
      flex-direction: column;
    }
  
    .thank-close {
      width: 100%;
      padding: 10px;
      font-size: 1rem;
    }
  }
  

  /* Profile Picture */
  .emp-profile-pic {
    width: 45px;
    height: 45px;
    flex-shrink: 0;
    border-radius: 50%;
  }

  /* Cancel Button */
  .empform-cancel-button {
    width: auto;
    margin: 0 auto;
  }

  /* Stars Rating */
  .stars-container {
    font-size: 20px;
  }
  .attachment-icon
  {
    margin-right: 5%;
  }
  .end {
    display: flex;
    justify-content: flex-end;
    margin-right: 8%;
    gap: 2%;
  }






  
.emp-message-container {
  display: flex;
  flex-direction: column;
}

.emp-message-header {
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 8px;
  color: #555;
  text-align: left; /* Default alignment for left */
}
.message-time
{
  font-size: 65%;
}


.emp-message-container.right .emp-message-header {
  text-align: right; /* Align to the right for 'You' */
  
}

.emp-message-container.left .emp-message-header {
  text-align: left; /* Align to the left for others' names */
}

.emp-message {
  max-width: 60%;
  padding: 10px;
 
  border-radius: 10px;
}

.left .emp-message {
  background: #dbeafe;
  align-self: flex-start;
}

.right .emp-message {
  background: #001f3f;
  color: white;

  align-self: flex-end;
}
.emp-name {
  font-size: 70%;
  margin-top: 20%;
}
.emp-message-time {
  font-size: 3px;
  color: gray;
  display: block;
  margin-top: 10px;
}
.emp-message-preview {
  color: gray;
  font-size: 10px;
  margin-left: 0%;
  margin-top: 5%;
  overflow: hidden;
  text-overflow: ellipsis;
}
 
.compose-button {
  background-color: #0078ce;
  padding: 1% 2%;
  color: #fff;
  align-items: center;
  border-radius: 5px;
  font-size: 15px;
  border: none;
  margin-right: 20px;
  margin-top: 17px;
}
.compose-icon {
  padding: 0;
  font-size: medium;
  margin-bottom: -3%;
}
.toggle-switch
{
  width: 45%;
}
.emp-message
{
  padding: -20%;
}

.emp-message p{
  padding-bottom: -40px;
  font-size:80%;
}
emp-message-header
{
  padding-top:  10px;


}
emp-message-sender
{
  padding: 0px;
}
.empform-cancel-button {
  width: auto;
  margin: 0 auto;
}
.emp-close-button {
  font-size: 100%;
  cursor: pointer;
}

.emp-unread-dot {
  top: 5px;
  right: 10px;
  width: 25px;
  height: 15px;
  margin-top: 0%;
  padding: 0;
  font-size: small;
  color: #fff;
  text-align: center;
  background-color: #0078ce;
  border-radius: 50%;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/EmployeeQueries/EmployeeQuery.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,qBAAqB;EACpC,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAO,EAAE,yBAAyB;EAClC,aAAa;EACb,OAAO;AACT;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,wCAAwC;;EAExC;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;EACzB;EACA;IACE,6BAA6B;IAC7B,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,+CAA+C;AAC/C;EACE,aAAa;AACf;;AAEA,qCAAqC;AACrC;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA;EACE,iBAAiB,EAAE,iCAAiC;AACtD;;AAEA;EACE,gBAAgB,EAAE,wCAAwC;AAC5D;;AAEA;EACE,cAAc;EACd,aAAa;EACb,+BAA+B;EAC/B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,4BAA4B,EAAE,2DAA2D;EACzF,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf;wBACsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,QAAQ;EACR,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf;wBACsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,yBAAyB;EACpD,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf;wBACsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;;;;AAKA;EACE,0BAA0B;EAC1B;IACE,YAAY,EAAE,8BAA8B;IAC5C,aAAa;IACb,aAAa;IACb,UAAU;;IAEV,kCAAkC;;IAElC,sBAAsB;IACtB,gBAAgB,EAAE,+BAA+B;EACnD;;EAEA;IACE,sBAAsB,EAAE,yBAAyB;IACjD,SAAS;IACT,aAAa;IACb,eAAe;IACf,YAAY,EAAE,gCAAgC;;EAEhD;;EAEA,wBAAwB;EACxB;IACE,UAAU,EAAE,eAAe;;IAE3B,sBAAsB;IACtB,qBAAqB;IACrB;8CAC0C;;IAE1C,6BAA6B;EAC/B;;EAEA,2BAA2B;EAC3B;IACE,YAAY,EAAE,mBAAmB;IACjC,gBAAgB,EAAE,gCAAgC;IAClD,kBAAkB,EAAE,2BAA2B;IAC/C,aAAa;IACb,iBAAiB,EAAE,0BAA0B;IAC7C,SAAS;IACT,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW,EAAE,kCAAkC;EACjD;;EAEA;IACE,8BAA8B,EAAE,2BAA2B;IAC3D,mBAAmB;EACrB;;EAEA,iBAAiB;EACjB;IACE,WAAW;IACX,0CAA0C;IAC1C,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,kCAAkC;;IAElC,8BAA8B;EAChC;;EAEA;IACE,+BAA+B,EAAE,4BAA4B;IAC7D,gBAAgB;IAChB,aAAa;EACf;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,QAAQ;IACR,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;;EAEnB;;EAEA;IACE,YAAY,EAAE,yBAAyB;IACvC,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,kBAAkB;EAClB;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;EACd;;EAEA,UAAU;EACV;IACE;MACE,UAAU,EAAE,uBAAuB;MACnC,OAAO;MACP,WAAW;IACb;;IAEA;;;MAGE,iBAAiB;MACjB,YAAY;IACd;;IAEA;MACE,WAAW;MACX,eAAe;IACjB;;IAEA;MACE,wBAAwB,EAAE,+BAA+B;IAC3D;;IAEA;MACE,WAAW;MACX,WAAW;MACX,gBAAgB;IAClB;;IAEA;MACE,WAAW,EAAE,qCAAqC;MAClD,eAAe;MACf,aAAa;MACb,yBAAyB;IAC3B;;IAEA;MACE,WAAW;MACX,cAAc;MACd,eAAe;MACf,aAAa;IACf;;IAEA;MACE,eAAe;MACf,uBAAuB;MACvB,QAAQ;IACV;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,WAAW;MACX,aAAa;MACb,eAAe;IACjB;EACF;;;EAGA,oBAAoB;EACpB;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;EACpB;;EAEA,kBAAkB;EAClB;IACE,WAAW;IACX,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,eAAe;EACjB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,OAAO;EACT;;;;;;;;AAQF;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,gBAAgB,EAAE,+BAA+B;AACnD;AACA;;EAEE,cAAc;AAChB;;;AAGA;EACE,iBAAiB,EAAE,iCAAiC;;AAEtD;;AAEA;EACE,gBAAgB,EAAE,wCAAwC;AAC5D;;AAEA;EACE,cAAc;EACd,aAAa;;EAEb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;;EAEZ,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;AACA;;EAEE,kBAAkB;;;AAGpB;AACA;;EAEE,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA","sourcesContent":[".emp-query-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh; /* Adjust as needed */\n  width: 100%;\n}\n\n.emp-query-header {\n  width: 96%;\n  padding: 2%;\n  text-align: left;\n  font-weight: bold;\n}\n\n.emp-query-content {\n  display: flex;\n  flex: 1; /* Takes up full height */\n  padding: 0 2%;\n  gap: 2%;\n}\n\n.emp-sidebar {\n  width: 30%;\n  padding: 10px;\n  background-color: #f8fafb;\n  overflow-y: auto;\n  border-radius: 10px;\n  margin-bottom: 5%;\n}\n\n.emp-chat-container {\n  width: 70%;\n  padding: 10px;\n  background-color: #ffffff;\n  overflow-y: auto;\n  border-radius: 10px;\n  margin-bottom: 5%;\n}\n\n.emp-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.emp-resolved-btn {\n  background: transparent;\n  border: 2px solid #007bff;\n  color: #007bff;\n  padding: 8px 16px;\n  cursor: pointer;\n  border-radius: 5px;\n  font-size: 14px;\n  transition: background 0.3s, color 0.3s;\n}\n\n.emp-resolved-btn.active {\n  background: #007bff;\n  color: white;\n}\n\n.emp-query-list {\n  height: calc(100vh - 80px);\n  overflow-y: scroll;\n  scrollbar-width: thin;\n  scrollbar-color: transparent transparent;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: transparent;\n    border-radius: 10px;\n  }\n}\n\n.emp-query-list::-webkit-scrollbar {\n  display: none;\n}\n\n.emp-query-list:hover::-webkit-scrollbar {\n  display: block;\n}\n\n.emp-query-item {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  margin: 2%;\n  cursor: pointer;\n  transition: 0.2s;\n  position: relative;\n  border-bottom: 2px solid #ccc;\n}\n\n.emp-query-item:hover,\n.emp-query-item.active {\n  background: #ffffff;\n  border-radius: 0;\n  margin: 2%;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);\n}\n\n.emp-profile-pic {\n  width: 40px;\n  height: 40px;\n  background: #ccc;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\n.emp-query-info {\n  flex-grow: 1;\n}\n\n.emp-query-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.emp-name {\n  font-weight: bold;\n  margin: 0;\n}\n\n.emp-time {\n  font-size: 12px;\n  color: gray;\n  margin: 10px;\n}\n\n.emp-message-preview {\n  color: gray;\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 200px;\n  display: inline-block;\n  margin: 0;\n}\n\n.emp-unread-dot {\n  top: 5px;\n  right: 10px;\n  width: 15px;\n  height: 15px;\n  margin: 0%;\n  padding: 0;\n  font-size: small;\n  color: #fff;\n  text-align: center;\n  background-color: #0078ce;\n  border-radius: 50%;\n}\n\n.emp-message-preview.unread-message {\n  color: #0078ce;\n}\n\n.emp-time,\n.emp-message-preview {\n  margin: 0 0 0 10px;\n}\n\n.emp-query-header .name {\n  flex-grow: 1;\n}\n\n/* Hide scrollbar */\n.emp-chat-messages {\n  display: flex;\n  flex-direction: column-reverse;\n  overflow-y: auto;\n  height: 470px;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n/* Hide scrollbar for WebKit (Chrome, Safari) */\n.emp-chat-messages::-webkit-scrollbar {\n  display: none;\n}\n\n/* Disabled input and button styles */\n.emp-chat-input input:disabled,\n.emp-chat-input button:disabled {\n  background: #e0e0e0;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.emp-message-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.emp-message-header {\n  font-weight: bold;\n  margin-bottom: 5px;\n  font-size: 14px;\n  color: #555;\n  text-align: left; /* Default alignment for left */\n}\n\n.emp-message-container.right .emp-message-header {\n  text-align: right; /* Align to the right for 'You' */\n}\n\n.emp-message-container.left .emp-message-header {\n  text-align: left; /* Align to the left for others' names */\n}\n\n.emp-message {\n  max-width: 60%;\n  padding: 0.5%;\n  border-radius: 10px 10px 10px 0;\n  word-wrap: break-word;\n  white-space: pre-wrap;\n}\n\n.left .emp-message {\n  background: #dbeafe;\n  align-self: flex-start;\n}\n\n.right .emp-message {\n  background: #001f3f;\n  color: white;\n  align-self: flex-end;\n}\n\n.emp-message-time {\n  font-size: 12px;\n  color: gray;\n  display: block;\n  margin-top: 5px;\n}\n\n.emp-chat-input {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  margin-top: 2%;\n}\n\n.input-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.message-input {\n  width: 90%;\n  padding: 1.5% 50px 1.5% 10px; /* Reduced right padding to make room for icon and suffix */\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.attachment-suffix {\n  position: absolute;\n  right: 80px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #333;\n  font-size: 14px;\n  pointer-events: none;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.attachment-icon {\n  position: absolute;\n  right: 4%;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  color: #666;\n  font-size: 20px;\n  z-index: 2;\n}\n\n.attachment-icon:hover {\n  color: #333;\n}\n\n/* For employee submit button, same interactive styles */\n.emp-submit-btn {\n  background-color: #7fbd2c;\n  width: 10%;\n  color: white;\n  border: none;\n  padding: 1.5% 2%;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n.emp-submit-btn:hover {\n  background-color: #68a822; /* Slightly darker */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.emp-submit-btn:active {\n  transform: scale(0.98);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.emp-submit-btn:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.emp-chat-input .submit-btn:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.emp-select-query {\n  text-align: center;\n  margin-top: 50px;\n  font-size: 18px;\n  color: gray;\n}\n\n.employee-query-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.employee-query-modal {\n  background-color: #e8e9ea;\n  padding: 0;\n  width: 600px;\n  top: 8%;\n  position: relative;\n  font-family: \"Arial\", sans-serif;\n}\n\n.employee-query-textarea::placeholder {\n  font-family: inherit;\n  font-size: 1rem;\n  color: #999;\n}\n\n.employee-query-input::placeholder {\n  font-family: inherit;\n  font-size: 1rem;\n  color: #999;\n}\n\n.emp-form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0% 5%;\n  margin: 0;\n  background-color: #00468c;\n  color: #fff;\n}\n\n.emp-close-button {\n  font-size: 1.5vw;\n  cursor: pointer;\n}\n\n.compose-icon {\n  padding: 0;\n  font-size: large;\n}\n\n/* Form Fields */\n.employee-query-form {\n  margin: 0;\n  padding: 5%;\n  width: 90%;\n}\n\n.employee-query-field {\n  margin-bottom: 15px;\n}\n\n.employee-query-label {\n  display: block;\n  font-weight: bold;\n  color: #555;\n  margin-bottom: 5px;\n}\n\n.employee-query-input,\n.employee-query-textarea,\n.employee-query-select {\n  width: 100%;\n  padding: 10px;\n  font-size: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-sizing: border-box;\n  margin-bottom: 10px;\n  font-family: inherit;\n}\n\n.employee-query-textarea {\n  resize: none;\n  height: 100px;\n}\n\n.empform-cancel-button {\n  width: 15%;\n  padding: 1%;\n  font-size: 1rem;\n  color: #000;\n  background-color: transparent;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  border: 0.2vw solid #79c42b;\n  margin: 0 0 2% 60%;\n}\n\n/* Buttons */\n.employee-query-button {\n  padding: 1%;\n  font-size: 1rem;\n  color: #fff;\n  background-color: #79c42b;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  border: 0.2vw solid #79c42b;\n  margin-left: 2%;\n}\n\n.employee-query-button:hover {\n  background-color: #218838;\n}\n\n.feedback-para {\n  font-size: small;\n  font-weight: bold;\n}\n\n.feedback-options {\n  padding: 1% 5%;\n}\n\n.stars-container {\n  display: flex;\n  justify-content: flex-start;\n  gap: 8px;\n  font-size: 24px;\n  cursor: pointer;\n  margin: 2% 0 5% 0;\n}\n\n.star {\n  color: gray;\n  transition: color 0.3s ease-in-out;\n}\n\n.star:hover,\n.star.selected {\n  color: gold;\n}\n\n.stars-info {\n  color: blue;\n  font-style: italic;\n}\n\n.thank-you {\n  text-align: center;\n  font-size: medium;\n  font-weight: bold;\n}\n\n.thank-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.thank-close {\n  background-color: #7fbd2c;\n  color: #fff;\n  padding: 1% 2%;\n  margin: 2%;\n  border-radius: 5px;\n  border: none;\n}\n\n.compose {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.end {\n  display: flex;\n  justify-content: flex-end;\n  gap: 2%;\n}\n\n.compose-button {\n  background-color: #0078ce;\n  padding: 1% 2%;\n  color: #fff;\n  align-items: center;\n  border-radius: 5px;\n  font-size: 20px;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n.compose-button:hover {\n  background-color: #006bb3; /* Slightly darker blue */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.compose-button:active {\n  transform: scale(0.98);\n}\n\n.compose-button:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.close-thread-button {\n  background-color: #ffffff;\n  border: 2px solid #0078ce;\n  color: #0078ce;\n  text-align: center;\n  border-radius: 5px;\n  padding: 0.5%;\n  font-size: medium;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n.close-thread-button:hover {\n  background-color: #f2f2f2;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.close-thread-button:active {\n  transform: scale(0.98);\n}\n\n.close-thread-button:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.close-thread-icon {\n  font-size: medium;\n}\n\n.message-text {\n  padding: 0 1%;\n}\n\n\n\n\n@media (max-width: 768px) {\n  /* Container Adjustments */\n  .emp-query-container {\n    height: 100%; /* Full height to fit screen */\n    display: flex;\n    height: 125vh;\n    width: 98%;\n    \n    border-radius: 10px 30px 30px 10px;\n    \n    flex-direction: column;\n    overflow: hidden; /* Prevent unnecessary scroll */\n  }\n\n  .emp-query-content {\n    flex-direction: column; /* Stack sidebar & chat */\n    gap: 10px;\n    display: flex;\n    flex-wrap: wrap;\n    flex-grow: 0; /* Allow it to take full space */\n    \n  }\n\n  /* Sidebar Adjustments */\n  .emp-sidebar {\n    width: 96%; /* Full width */\n\n    /* overflow-x: auto; */\n    /* padding: 10px 0; */\n    /* white-space: nowrap;\n    background: #f8f9fa; /* Light background */\n \n    border-bottom: 1px solid #ddd;\n  }\n\n  /* Query List Adjustments */\n  .emp-query-list {\n    height: auto; /* Dynamic height */\n    overflow-x: auto; /* Enable horizontal scrolling */\n    overflow-y: hidden; /* Remove vertical scroll */\n    display: flex;\n    flex-wrap: nowrap; /* Keep items in one row */\n    gap: 10px;\n    padding: 5px;\n    margin-top: -5%;\n    align-items: center;\n  }\n\n  .emp-query-list::-webkit-scrollbar {\n    height: 5px; /* Slightly larger for usability */\n  }\n\n  .emp-query-list::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.3); /* More visible scrollbar */\n    border-radius: 10px;\n  }\n\n  /* Chat Section */\n  .emp-chat-container {\n    width: 100%;\n    /* flex-grow: 1; /* Expand to fill space */\n    display: flex;\n    /* height: 50%; */\n    height: 84vh;\n    flex-direction: column;\n    border-radius: 10px 30px 30px 10px;\n \n    justify-content: space-between; \n  }\n\n  .emp-chat-messages {\n    max-height: calc(100vh - 300px); /* Adjust for screen space */\n    overflow-y: auto;\n    padding: 10px;\n  }\n\n  /* Input Field */\n  .input-container {\n    display: flex;\n    gap: 5px;\n    margin-top: 0%;\n    margin-right: -2%;\n    padding: 10px;\n    align-items: center;\n    background: white;\n   \n  }\n\n  .input-container input {\n    flex-grow: 1; /* Fill available space */\n    font-size: 14px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n  }\n\n  /* Submit Button */\n  .emp-submit-btn {\n    width: auto;\n    padding: 10px 15px;\n    font-size: 14px;\n    background: #7fbd2c;\n    color: white;\n    margin-right: 9%;\n    border-radius: 5px;\n    border: none;\n  }\n\n  /* Modal */\n  @media (max-width: 768px) {\n    .employee-query-modal {\n      width: 80%; /* Adjust modal width */\n      top: 5%;\n      padding: 3%;\n    }\n  \n    .employee-query-textarea,\n    .employee-query-input,\n    .employee-query-select {\n      font-size: 0.9rem;\n      padding: 8px;\n    }\n  \n    .emp-form-header {\n      padding: 5%;\n      font-size: 1rem;\n    }\n  \n    .emp-close-button {\n      font-size: 6vw!important; /* Increase close button size */\n    }\n  \n    .employee-query-form {\n      width: 100%;\n      padding: 5%;\n      margin-left: -4%;\n    }\n  \n    .employee-query-button {\n      width: 100%; /* Full width for better tapability */\n      font-size: 1rem;\n      padding: 10px;\n      margin: 10px 0px 10px 0px;\n    }\n  \n    .empform-cancel-button {\n      width: 100%;\n      margin: 10px 0;\n      font-size: 1rem;\n      padding: 10px;\n    }\n  \n    .stars-container {\n      font-size: 20px;\n      justify-content: center;\n      gap: 5px;\n    }\n  \n    .feedback-options {\n      padding: 3%;\n    }\n  \n    .thank-you {\n      font-size: 1rem;\n    }\n  \n    .thank-button {\n      flex-direction: column;\n    }\n  \n    .thank-close {\n      width: 100%;\n      padding: 10px;\n      font-size: 1rem;\n    }\n  }\n  \n\n  /* Profile Picture */\n  .emp-profile-pic {\n    width: 45px;\n    height: 45px;\n    flex-shrink: 0;\n    border-radius: 50%;\n  }\n\n  /* Cancel Button */\n  .empform-cancel-button {\n    width: auto;\n    margin: 0 auto;\n  }\n\n  /* Stars Rating */\n  .stars-container {\n    font-size: 20px;\n  }\n  .attachment-icon\n  {\n    margin-right: 5%;\n  }\n  .end {\n    display: flex;\n    justify-content: flex-end;\n    margin-right: 8%;\n    gap: 2%;\n  }\n\n\n\n\n\n\n  \n.emp-message-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.emp-message-header {\n  font-weight: bold;\n  margin-bottom: 5px;\n  font-size: 8px;\n  color: #555;\n  text-align: left; /* Default alignment for left */\n}\n.message-time\n{\n  font-size: 65%;\n}\n\n\n.emp-message-container.right .emp-message-header {\n  text-align: right; /* Align to the right for 'You' */\n  \n}\n\n.emp-message-container.left .emp-message-header {\n  text-align: left; /* Align to the left for others' names */\n}\n\n.emp-message {\n  max-width: 60%;\n  padding: 10px;\n \n  border-radius: 10px;\n}\n\n.left .emp-message {\n  background: #dbeafe;\n  align-self: flex-start;\n}\n\n.right .emp-message {\n  background: #001f3f;\n  color: white;\n\n  align-self: flex-end;\n}\n.emp-name {\n  font-size: 70%;\n  margin-top: 20%;\n}\n.emp-message-time {\n  font-size: 3px;\n  color: gray;\n  display: block;\n  margin-top: 10px;\n}\n.emp-message-preview {\n  color: gray;\n  font-size: 10px;\n  margin-left: 0%;\n  margin-top: 5%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n \n.compose-button {\n  background-color: #0078ce;\n  padding: 1% 2%;\n  color: #fff;\n  align-items: center;\n  border-radius: 5px;\n  font-size: 15px;\n  border: none;\n  margin-right: 20px;\n  margin-top: 17px;\n}\n.compose-icon {\n  padding: 0;\n  font-size: medium;\n  margin-bottom: -3%;\n}\n.toggle-switch\n{\n  width: 45%;\n}\n.emp-message\n{\n  padding: -20%;\n}\n\n.emp-message p{\n  padding-bottom: -40px;\n  font-size:80%;\n}\nemp-message-header\n{\n  padding-top:  10px;\n\n\n}\nemp-message-sender\n{\n  padding: 0px;\n}\n.empform-cancel-button {\n  width: auto;\n  margin: 0 auto;\n}\n.emp-close-button {\n  font-size: 100%;\n  cursor: pointer;\n}\n\n.emp-unread-dot {\n  top: 5px;\n  right: 10px;\n  width: 25px;\n  height: 15px;\n  margin-top: 0%;\n  padding: 0;\n  font-size: small;\n  color: #fff;\n  text-align: center;\n  background-color: #0078ce;\n  border-radius: 50%;\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
